const TICKET_API_BASE_URL = "http://staging.maamaas.com:8080/protohub/support/ticket";

// Hardcoded per current requirements — swap for the logged-in expert's id later.
const EXPERT_ID = 1;
const USER_TYPE = "INNOVATOR";

/**
 * Creates a support ticket via the backend API.
 *
 * @param {Object} params
 * @param {string} params.subject
 * @param {string} params.message
 * @param {"MACHINE_ISSUE"|"SOFTWARE"|"BILLING"|"BOOKING"|"ACCESS"|"OTHER"} params.category
 * @param {"LOW"|"MEDIUM"|"HIGH"} params.priority
 * @returns {Promise<Object>} the created ticket as returned by the API
 */
export async function createSupportTicket({ subject, message, category, priority }) {
    const now = new Date().toISOString();

    const payload = {
        expertId: EXPERT_ID,
        userType: USER_TYPE,
        subject,
        message,
        category,
        priority,
        status: "OPEN",
        createdAt: now,
        updatedAt: now,
    };

    const response = await fetch(TICKET_API_BASE_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        let errorMessage = `Failed to raise ticket (status ${response.status})`;
        try {
            const errorBody = await response.json();
            errorMessage = errorBody?.message || errorMessage;
        } catch {
            // response wasn't JSON — fall back to the generic message above
        }
        throw new Error(errorMessage);
    }

    return response.json();
}

/**
 * Fetches all support tickets raised against a given expert.
 *
 * @param {number} [expertId] defaults to the hardcoded EXPERT_ID
 * @returns {Promise<Array<Object>>} the raw list of tickets as returned by the API
 */
export async function getExpertTickets(expertId = EXPERT_ID) {
    const response = await fetch(`${TICKET_API_BASE_URL}/expert/${expertId}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
        },
    });

    if (!response.ok) {
        let errorMessage = `Failed to load tickets (status ${response.status})`;
        try {
            const errorBody = await response.json();
            errorMessage = errorBody?.message || errorMessage;
        } catch {
            // response wasn't JSON — fall back to the generic message above
        }
        throw new Error(errorMessage);
    }

    return response.json();
}